import { Box, CardActions } from "@mui/material";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import tagEntitiesAPI from "../../_api/_tagEntitiesAPI";
import AutocompleteTag from "../AutocompleteTag";
import NewTagList from "./NewTagList";

const NewTagCard = ({ personId, type, style }: any) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const entityUrl = `/api/people/${personId}`;

  const { data: dataEntities, loading } = useFetch(
    tagEntitiesAPI.get({ entity: entityUrl })
  );

  const [tagEntities, setTagEntities] = useState<any>([]);

  const removeTagEntity = (id: string) => {
    setTagEntities((current: any) =>
      current.filter((el: any) => el["@id"] !== id)
    );
  };

  const updateTagColor = (tagId: string, newColor: string) => {
    setTagEntities((current: any) =>
      current.map((tagEntity: { tag: { id: string } }) =>
        tagEntity.tag.id === tagId
          ? { ...tagEntity, tag: { ...tagEntity.tag, color: newColor } }
          : tagEntity
      )
    );
  };

  useEffect(() => {
    setTagEntities(dataEntities?.["hydra:member"]);
  }, [dataEntities]);

  return (
    <div style={style}>
      <Box>
        <Box
          onClick={undefined}
          sx={{
            paddingInline: "16px",
            paddingTop: "15px",
            paddingBottom: "5px",
          }}
        >
          {!loading ? (
            <NewTagList
              removeTagEntity={removeTagEntity}
              tagEntities={tagEntities}
              setIsEdit={setIsEdit}
              personId={personId}
              updateTagColor={updateTagColor}
              type={type}
              needModal={true}
              setTagEntities={setTagEntities}
            />
          ) : null}
        </Box>
        <CardActions
          sx={{
            justifyContent: "center",
          }}
        >
          {isEdit ? (
            <AutocompleteTag
              type={type}
              personId={personId}
              tagEntities={tagEntities}
              setTagEntities={setTagEntities}
            />
          ) : null}
        </CardActions>
      </Box>
    </div>
  );
};

export default NewTagCard;
